"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodedQueryParam = encodedQueryParam;
exports.parseNumberFromQueryParam = parseNumberFromQueryParam;
exports.parseQueryParam = parseQueryParam;
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isElement2 = _interopRequireDefault(require("lodash/isElement"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _queryString = _interopRequireDefault(require("query-string"));
function parseQueryParam(searchQuery, paramName) {
  var queryParams = _queryString["default"].parse(searchQuery);
  var param = (0, _get2["default"])(queryParams, paramName, '');
  // multiple params may get passed through with the same param name - use first param
  return (0, _isElement2["default"])(param) || (0, _isArray2["default"])(param) ? (0, _first2["default"])(param) : param;
}
function encodedQueryParam(searchQuery, paramName) {
  var queryParams = _queryString["default"].parse(searchQuery);
  var param = (0, _get2["default"])(queryParams, paramName, '');
  var encodedParam = encodeURIComponent(param);
  return encodedParam;
}
function parseNumberFromQueryParam(searchQuery, paramName) {
  var parsedValue = parseInt(parseQueryParam(searchQuery, paramName), 10);
  return (0, _isNaN2["default"])(parsedValue) ? undefined : parsedValue;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/helpers/contactPreferences.helpers.js
// module id = 2105
// module chunks = 9